import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { FormControl, OutlinedInput, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import { API_BASE_URL } from "../../../apiConfig";
import Add from "./Add.js";
import Edit from "./Edit.js";
import Delete from "./Delete.js";
import ArticleModal from "./ArticleModal.js";
import TelegramIcon from "@mui/icons-material/Telegram";
import { refreshTokenIfNeeded } from "../refreshTokenIfNeeded";

export default function ManageArticles() {
  const [rows, setRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedStoreId, setSelectedStoreId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editSroreModalOpen, setEditStoreModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [triggerSearch, setTriggerSearch] = useState(false);
  const [addCarModalOpen, setAddCarModalOpen] = useState(false);

  const [showConfirm, setShowConfirm] = useState(false);
  const [articleIdToDelete, setArticleIdToDelete] = useState(null);
  const [nameToDelete, setNameToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [refreshFlag, setRefreshFlag] = useState(false);

  const fetchData = async (page, searchQuery) => {
    let token = localStorage.getItem("token");

    if (!token) {
      throw new Error("Token not available. Please log in.");
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}Article/GetAllByPage/${page + 1}/${searchQuery}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.article && response.data.article.length > 0) {
        const formattedData = response.data.article.map((article) => ({
          id: article.id,
          title: article.title,
          description: article.description,
          imageURL: article.imageURL,
          slug: article.slug,
          metaDescription: article.metaDescription,
        }));

        setRows(formattedData);
        setTotalRecords(response.data.allRecord);
      } else {
        setRows([]);
        setTotalRecords(0);
      }
    } catch (error) {
      // إذا انتهت صلاحية التوكن
      if (error.response?.status === 401) {
        try {
          const newToken = await refreshTokenIfNeeded();
          if (!newToken) {
            return navigate("/", { replace: true });
          }

          // إعادة الطلب بالتوكن الجديد
          const response = await axios.get(
            `${API_BASE_URL}Article/GetAllByPage/${page + 1}/${searchQuery}`,
            {
              headers: {
                Authorization: `Bearer ${newToken}`,
              },
            },
          );

          if (response.data.article && response.data.article.length > 0) {
            const formattedData = response.data.article.map((article) => ({
              id: article.id,
              title: article.title,
              description: article.description,
              imageURL: article.imageURL,
              slug: article.slug,
              metaDescription: article.metaDescription,
            }));

            setRows(formattedData);
            setTotalRecords(response.data.allRecord);
          } else {
            setRows([]);
            setTotalRecords(0);
          }
        } catch (retryError) {
          console.error("Retry failed:", retryError);
          setRows([]);
          setTotalRecords(0);
        }
      } else {
        console.error("Error fetching data:", error);
        setRows([]);
        setTotalRecords(0);
      }
    }
  };

  const handlePaginationChange = (paginationModel) => {
    setCurrentPage(paginationModel.page);
  };

  const handleSearch = () => {
    //setCurrentPage(0);
    setTriggerSearch(!triggerSearch);
  };

  const handleClear = () => {
    setSearchValue("");
    //setCurrentPage(0);
    setTriggerSearch(!triggerSearch);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  // useEffect(() => {
  //   fetchData(currentPage, searchValue);
  // });

  useEffect(() => {
    fetchData(currentPage, searchValue);
  }, [currentPage, triggerSearch, refreshFlag]);

  const handleDeleteClick = (id, title) => {
    setArticleIdToDelete(id);
    setNameToDelete(title);
    setShowConfirm(true);
    // fetchData(currentPage, searchValue);
  };

  const handleConfirmDelete = () => {
    const token = localStorage.getItem("token");

    axios
      .delete(`${API_BASE_URL}Article/Delete/${articleIdToDelete}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        alert("تم حذف المقال بنجاح.");
        setShowConfirm(false);
        setArticleIdToDelete(null);
        fetchData(currentPage, searchValue);
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          // إذا انتهت صلاحية التوكن، نجدد ونعيد الطلب
          refreshTokenIfNeeded()
            .then((newToken) => {
              if (!newToken) {
                return navigate("/", { replace: true });
              }

              return axios.delete(
                `${API_BASE_URL}Article/Delete/${articleIdToDelete}`,
                {
                  headers: {
                    Authorization: `Bearer ${newToken}`,
                  },
                },
              );
            })
            .then(() => {
              alert("تم حذف المقال بنجاح.");
              setShowConfirm(false);
              setArticleIdToDelete(null);
              fetchData(currentPage, searchValue);
            })
            .catch((retryError) => {
              alert("Retry failed: " + retryError.message);
            });
        } else {
          alert("حدث خطأ أثناء محاولة حذف المقال.");
        }
      });
  };
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    return text.substring(0, 50); // فقط أول 50 حرف
  };

  const refreshData = () => {
    fetchData(currentPage, searchValue);
    setRefreshFlag((prev) => !prev);
  };
  const handleCancelDelete = () => {
    setShowConfirm(false);
    setArticleIdToDelete(null);
  };

  const handleView = (id) => {
    setSelectedStoreId(id);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedStoreId(null);
  };

  const handleAddRow = () => {
    setAddCarModalOpen(true);
  };

  const handleCloseAddCarModal = () => {
    //fetchData(currentPage, searchValue);
    refreshData();
    setAddCarModalOpen(false);
    // setSearchValue(searchValue || "");
  };

  const handleEdit = (id) => {
    setSelectedStoreId(id);
    setEditStoreModalOpen(true);
  };
  const handleCloseEditCarModal = () => {
    // fetchData(currentPage, searchValue);
    refreshData();
    setEditStoreModalOpen(false);
    // setSearchValue(searchValue || "");
    //fetchData(currentPage);
  };

  const handleVisitSlug = (slug) => {
    const url = `https://couponfirstorder.com/blog/${slug}`;
    window.open(url, "_blank"); // "_blank" تعني نافذة جديدة
  };

  const columns = [
    {
      field: "actions",
      headerName: "الإجراءات",
      flex: 2,
      renderCell: (params) => (
        <>
          {/* <IconButton onClick={() => handleEdit(params.row.id)}>
            <DescriptionIcon sx={{ color: "#607D8B" }} />
          </IconButton> */}
          <IconButton
            color="error"
            onClick={() => handleDeleteClick(params.row.id, params.row.title)}
          >
            <DeleteIcon />
          </IconButton>

          <IconButton onClick={() => handleEdit(params.row.id)}>
            <EditIcon sx={{ color: "green" }} />
          </IconButton>
          <IconButton color="primary" onClick={() => handleView(params.row.id)}>
            <VisibilityIcon />
          </IconButton>

          <IconButton
            sx={{ color: "#5b5b5c" }}
            onClick={() => handleVisitSlug(params.row.slug)}
          >
            <TelegramIcon />
          </IconButton>
        </>
      ),

      headerAlign: "right",
      align: "right",
    },

    {
      field: "metaDescription",
      headerName: "وصف الميتا",
      flex: 2,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        const cleanText = stripHtml(params.row.metaDescription || "").substring(
          0,
          100,
        );
        return `${cleanText}...`;
      },
    },
    {
      field: "slug",
      headerName: "اسم الرابط",
      flex: 3,
      headerAlign: "right",
      align: "right",
    },

    {
      field: "title",
      headerName: "اسم المقال",
      flex: 5,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => {
        const text = params.value; // النص داخل الخلية
        const isArabic = /[\u0600-\u06FF]/.test(text); // التحقق إذا كان النص يحتوي على أحرف عربية
        const direction = isArabic ? "rtl" : "ltr"; // تحديد الاتجاه بناءً على النص

        return (
          <div
            style={{
              direction: direction,
              textAlign: direction === "rtl" ? "right" : "left",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {text}
          </div>
        );
      },
    },
    {
      field: "imageURL",
      headerName: "صورة المقال",
      flex: 1,
      headerAlign: "right",
      align: "right",
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: 100, // عرض المربع
            height: 50, // ارتفاع المربع
            overflow: "hidden",
            borderRadius: "5px",
            //  border: "1px solid #ccc", // إضافة حدود
          }}
        >
          <img
            src={params.value}
            alt="article"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Box>
      ),
    },
  ];

  return (
    <div
      dir={"rtl"}
      style={{
        color: "white",
        maxWidth: "100%",
        maxHeight: "100%",
        fontFamily: "'Changa', sans-serif",
      }}
    >
      <h3>إدارة المدونة - المقالات</h3>
      <div
        dir={"ltr"}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "7%",
        }}
      >
        <div dir="rtl" style={{ width: "50%" }}>
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <OutlinedInput
              placeholder="ابحث بعنوان المقال"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={handleKeyDown}
              sx={{
                color: "#5b5b5c",
                backgroundColor: "#fff",
                borderRadius: "4px",
                "& input": { color: "#303031" },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#5b5b5c",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#5b5b5c",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#0064b7",
                },
              }}
              endAdornment={
                <InputAdornment position="end">
                  {searchValue && (
                    <IconButton onClick={handleClear}>
                      <ClearIcon />
                    </IconButton>
                  )}
                  <IconButton onClick={handleSearch}>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1%",
          }}
        >
          <Button variant="contained" color="primary" onClick={handleAddRow}>
            اضف مقال
          </Button>
        </div>

        <Box
          sx={{
            height: "67%",
            width: "100%",
          }}
        >
          <DataGrid
            style={{ background: "#f3f3f3" }}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 8,
                },
              },
            }}
            pageSizeOptions={[8]}
            paginationMode="server"
            rowCount={totalRecords}
            disableRowSelectionOnClick
            onPaginationModelChange={(model) => {
              setIsLoading(true); // عند بدء تحميل الصفحة، تفعيل حالة التحميل
              handlePaginationChange(model);
              setIsLoading(false); // إلغاء حالة التحميل بعد استرجاع البيانات
            }}
            disableColumnFilter={true}
            disableColumnSelector={true}
            disableColumnMenu={true}
            disableColumnSorting={true}
            autoHeight={true}
            localeText={{
              noRowsLabel: "",
            }}
            sx={{
              "& .MuiTablePagination-actions > button": {
                transform: "rotate(180deg)",
              },
              "& .MuiDataGrid-columnHeaders": {
                direction: "ltr",
                textAlign: "right",
              },
              "& .MuiDataGrid-cell": {
                direction: "ltr",
                textAlign: "right",
              },
              "& .MuiDataGrid-footerContainer": {
                justifyContent: "flex-start",
              },
              "& .MuiTablePagination-toolbar": {
                direction: "rtl",
              },
              "& .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus-within": {
                outline: "none",
              },
            }}
          />
        </Box>
        {modalOpen && (
          <ArticleModal carId={selectedStoreId} onClose={handleCloseModal} />
        )}

        {addCarModalOpen && (
          <Add onClose={handleCloseAddCarModal} onSubmit={fetchData} />
        )}

        {editSroreModalOpen && (
          <Edit
            storeId={selectedStoreId}
            onClose={handleCloseEditCarModal}
            onSubmit={fetchData}
          />
        )}
        {showConfirm && (
          <Delete
            onConfirm={handleConfirmDelete}
            onCancel={handleCancelDelete}
            storeTitle={nameToDelete}
          />
        )}
      </div>
    </div>
  );
}
